import React, { ReactNode } from 'react';
import { MRT_DensityState } from 'material-react-table';

import './MaterialReactTable.scss';
import './TableCell.scss';

type Props = {
    density: MRT_DensityState;
    isTextOverflow: boolean;
    children: ReactNode;
    additionalClass?: string;
}

export const TableCell = (props: Props): React.ReactElement => {
    const { density, isTextOverflow, children, additionalClass } = props;

    return (
        <div
            data-cy="table-cell"
            className={`${additionalClass ?? ''} ${isTextOverflow ? 'fc-text-overflow' : ''} ${density ? 'fc-table-cell-compact' : ''}`}>
            {children}
        </div>
    );
};
